export var WeekPreset = /*#__PURE__*/ function(WeekPreset) {
    WeekPreset["ThisWeek"] = "this-week";
    WeekPreset["PreviousWeek"] = "previous-week";
    return WeekPreset;
}({});
export var WeekMenuActions = /*#__PURE__*/ function(WeekMenuActions) {
    WeekMenuActions["CopyFromSelectedWeek"] = "copy_from_selected_week";
    WeekMenuActions["CopyFromLastWeek"] = "copy_from_last_week";
    WeekMenuActions["AddFromAllocations"] = "add_from_allocations";
    return WeekMenuActions;
}({});
export var FilterViewType = /*#__PURE__*/ function(FilterViewType) {
    FilterViewType["ProjectsIOwn"] = "projects_i_own";
    FilterViewType["AllTimesheets"] = "all_timesheets";
    FilterViewType["Submitted"] = "submitted";
    FilterViewType["NotSubmitted"] = "not_submitted";
    FilterViewType["Approved"] = "approved";
    FilterViewType["Rejected"] = "rejected";
    FilterViewType["MyTeam"] = "my_team";
    return FilterViewType;
}({});
export const FilterViewOptions = [
    "my_team",
    "all_timesheets",
    "projects_i_own",
    "submitted",
    "not_submitted",
    "approved",
    "rejected"
];
export var TimeEntryState = /*#__PURE__*/ function(TimeEntryState) {
    TimeEntryState["NotCreated"] = "NotCreated";
    TimeEntryState["Creating"] = "Creating";
    TimeEntryState["PartiallyFilled"] = "PartiallyFilled";
    TimeEntryState["Loaded"] = "Loaded";
    return TimeEntryState;
}({});
export var TimesheetStatus = /*#__PURE__*/ function(TimesheetStatus) {
    TimesheetStatus["NotSubmitted"] = "not_submitted";
    TimesheetStatus["Submitted"] = "submitted";
    TimesheetStatus["Approved"] = "approved";
    TimesheetStatus["Rejected"] = "rejected";
    return TimesheetStatus;
}({});
export var WorkType = /*#__PURE__*/ function(WorkType) {
    WorkType["GoogleCalendar"] = "GOOGLE_CALENDAR";
    WorkType["OutlookCalendar"] = "OUTLOOK_CALENDAR";
    WorkType["Task"] = "TASK";
    WorkType["Project"] = "PROJECT";
    WorkType["Phase"] = "PHASE";
    WorkType["Adhoc"] = "ADHOC";
    WorkType["Milestone"] = "MILESTONE";
    return WorkType;
}({});
export var NoteType = /*#__PURE__*/ function(NoteType) {
    NoteType["TimesheetReject"] = "TIMESHEET_REJECT";
    return NoteType;
}({});
export var NoteSubType = /*#__PURE__*/ function(NoteSubType) {
    NoteSubType["ProjectReject"] = "PROJECT_REJECT";
    NoteSubType["WorkReject"] = "WORK_REJECT";
    NoteSubType["OverallReject"] = "OVERALL_REJECT";
    return NoteSubType;
}({});
